import {TriToggleModule} from './../../../widgets/tri-toggle/tri-toggle.module';
import {FiltersGroupModule} from './../../../widgets/filters/filters-group/filters-group.module';
import {ControlPopUpModule} from 'src/app/widgets/control-pop-up/control-pop-up.module';
import {PageOptionsPopUpButtonModule} from './../../../widgets/page-options-pop-up-button/page-options-pop-up-button.module';
import {DropDownFilterModule} from 'src/app/widgets';
import {DxTextBoxModule, DxButtonModule, DxDataGridModule, DxLoadPanelModule, DxPopupModule, DxChartModule, DxPivotGridModule, DxNumberBoxModule, DxBoxModule, DxAutocompleteModule, DxSelectBoxModule, DxScrollViewModule} from 'devextreme-angular';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {OrderOptimizerRoutingModule} from './order-optimizer-routing.module';
import {OrderOptimizerComponent} from './order-optimizer.component';
import {PageTitleModule} from 'src/app/components/page-title/page-title.module';
import { ReplenishmentTableComponent } from 'src/app/widgets/replenishment-table/replenishment-table.component';
import { HelpButtonComponent } from 'src/app/widgets/help-button/help-button.component';
import { ContainerComponent } from 'src/app/components/container/container.component';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';

@NgModule({
	declarations: [OrderOptimizerComponent],
	imports: [
		CommonModule,
		OrderOptimizerRoutingModule,

		PageOptionsPopUpButtonModule,
		ControlPopUpModule,
		FiltersGroupModule,
		ReplenishmentTableComponent,
		HelpButtonComponent,
		ContainerComponent,
		BookmarkNewComponent,

		DxTableControllerDirective,

		DxTextBoxModule,
		DxButtonModule,
		DxDataGridModule,
		DxLoadPanelModule,
		DxPopupModule,
		DxChartModule,
		DxPivotGridModule,
		DxNumberBoxModule,
		DxBoxModule,
		DxAutocompleteModule,
		DxSelectBoxModule,
		DxScrollViewModule,

		DropDownFilterModule,
		TriToggleModule,

		PageTitleModule,
	],
})
export class OrderOptimizerModule {}
